import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { coolGrey, grape, greyStroke, squidInk, white } from 'lib/css/colors';

function ActiveFilterChips({ filters, onClearAll }) {
  const visibleFilters = (filters || []).filter(
    filter => filter && filter.value !== undefined && filter.value !== null && filter.value !== '',
  );

  if (visibleFilters.length === 0) {
    return null;
  }

  return (
    <div className={css(styles.container)}>
      {visibleFilters.map(filter => (
        <span key={filter.label} className={css(styles.chip)}>
          <span className={css(styles.chipLabel)}>{filter.label}:</span>
          <span className={css(styles.chipValue)}>{filter.value}</span>
          <Button
            variant="link"
            className={css(styles.removeButton)}
            onClick={filter.onRemove}
            aria-label={`Remove ${filter.label} filter`}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </span>
      ))}
      {visibleFilters.length > 1 && onClearAll && (
        <Button
          variant="link"
          className={css(styles.clearAllButton)}
          onClick={onClearAll}
          aria-label="Clear all filters"
        >
          Clear all
        </Button>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    backgroundColor: white,
    border: `1px solid ${greyStroke}`,
    borderRadius: 16,
    padding: '4px 4px 4px 12px',
    fontSize: 12,
    fontWeight: 500,
    color: squidInk,
    lineHeight: 1.2,
  },
  chipLabel: {
    color: coolGrey,
    fontWeight: 600,
  },
  chipValue: {
    color: squidInk,
  },
  removeButton: {
    background: 'none',
    border: 'none',
    color: coolGrey,
    padding: '2px 6px',
    borderRadius: 12,
    fontSize: 11,
    lineHeight: 1,
    ':hover': {
      backgroundColor: `${grape}15`,
      color: grape,
      textDecoration: 'none',
    },
    ':focus': {
      textDecoration: 'none',
    },
  },
  clearAllButton: {
    background: 'none',
    border: 'none',
    color: grape,
    padding: '4px 8px',
    fontSize: 12,
    fontWeight: 600,
    ':hover': {
      color: grape,
      textDecoration: 'underline',
    },
  },
});

ActiveFilterChips.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onRemove: PropTypes.func.isRequired,
    }),
  ),
  onClearAll: PropTypes.func,
};

export default ActiveFilterChips;
